export const userConstants = {
    LOGIN_REQUEST: 'LOGIN_REQUEST',
    LOGIN_SUCCESS: 'LOGIN_SUCCESS',
    LOGIN_FAILURE: 'LOGIN_FAILURE',
    LOGIN_CHECK: 'LOGIN_CHECK',
    LOGIN_ACTIVE: 'LOGIN_ACTIVE',
    LOGIN_REFRESH: 'LOGIN_REFRESH',

    LOGOUT: 'LOGOUT',

    LOGIN_GETUSERPROFILE_REQUEST: 'LOGIN_GETUSERPROFILE_REQUEST',
    LOGIN_GETUSERPROFILE_SUCCESS: 'LOGIN_GETUSERPROFILE_SUCCESS',
    LOGIN_GETUSERPROFILE_FAILURE: 'LOGIN_GETUSERPROFILE_FAILURE',
}
